import { FC } from 'react';
import { Box, List, ListItem, Skeleton } from '@mui/material';

export const ChatListLoader: FC = () => (
  <Box
    sx={{
      bgcolor: 'background.paper',
      height: '100%',
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(0,0,0,0.1)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,0.3)',
        borderRadius: '2px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: 'rgba(0,0,0,0.5)',
      },
    }}
  >
    <List disablePadding>
      {[1, 2, 3].map((i) => (
        <ListItem
          key={i}
          sx={{
            p: 2,
            borderBottom: '1px solid #e0e0e0',
            borderLeft: '4px solid transparent',
            display: 'flex',
            gap: 2,
            width: '399px',
          }}
        >
          <Box sx={{ flex: 1, overflow: 'hidden', width: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Skeleton variant="text" width="60%" height={24} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
            <Skeleton variant="text" width="90%" height={14} sx={{ mt: 1 }} />
          </Box>
        </ListItem>
      ))}
    </List>
  </Box>
);

export default ChatListLoader;
